import { Injectable } from '@angular/core';
import { ListingExportConfig } from '@portal/shared/types/listing.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { TableData } from 'src/app/shared/types/api-response.types';
import { AlarmsRows } from '../services/alarm-data.types';
import { mapAlarmToExport } from './alarms-listing.export';

@Injectable()
export class AlarmsListingExportConfigService implements ListingExportConfig {
  readonly fileName = 'Export-Alarms';

  readonly mapData = (data: TableData<AlarmsRows>): ExportRow[] => data.data.map(mapAlarmToExport);
}
